import { forwardRef } from 'react'

const BASE =
  'bg-[var(--surface)] border border-[var(--border)] rounded-2xl ' +
  'shadow-[var(--shadow-sm)] transition-all duration-200'

const VARIANTS = {
  default: '',
  urgent:  'border-[var(--coral-soft)] bg-[var(--coral-tint)]',
  dashed:  'border-dashed bg-[var(--bg-soft)]',
}

const GlassCard = forwardRef(function GlassCard(
  { as: As = 'div', variant = 'default', hover = false, dim = false, className = '', children, ...props },
  ref,
) {
  const hoverCls = hover ? 'hover:shadow-[var(--shadow-md)] hover:-translate-y-0.5' : ''
  const dimCls   = dim   ? 'opacity-60' : ''
  return (
    <As ref={ref} className={`${BASE} ${VARIANTS[variant] ?? ''} ${hoverCls} ${dimCls} ${className}`} {...props}>
      {children}
    </As>
  )
})

export default GlassCard
